const initialState = {
	list: [],
	page: 1,
	count: 0,
	isListNext: false,
	datetime: null,
};

export default function reducer(state = initialState, action) {

	if (action.type === 'FAVORITE_PARTNER_LIST_SET') {
		let newState = Object.assign({}, state);
		newState.list = action.payload.list;
		newState.page = action.payload.page;
		newState.count = action.payload.count;
		newState.isListNext = action.payload.isListNext;
		newState.datetime = (new Date());
		return newState;
	}
	else if (action.type === 'FAVORITE_PARTNER_ITEM_SET') {
		let newState = Object.assign({}, state);
		if (action.payload.type === 'del') {
			let index = newState.list.findIndex((v) => v.userdata_id_code === action.payload.pic);
			if (index >= 0) {
				newState.list.splice( index, 1 );
			}
		}
		return newState;
	}
	else {
		return state;
	}
}
